import React, {Fragment} from 'react';
import dynamic from 'next/dynamic';


export const NoSsr = dynamic(() => Promise.resolve((
  props: React.PropsWithChildren<{}>,
) => <Fragment>{props.children}</Fragment>), {
  ssr: false,
});
